import { render, staticRenderFns } from "./BrokerClientListPage.vue?vue&type=template&id=49d524f0"
import script from "./BrokerClientListPage.vue?vue&type=script&lang=js"
export * from "./BrokerClientListPage.vue?vue&type=script&lang=js"
import style0 from "./BrokerClientListPage.vue?vue&type=style&index=0&id=49d524f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports